export default "__VITE_ASSET__80fc2d7f__"